<template>
  <v-card class="mb-4">
    <v-list-item
        dark
        class="accent"
    >
      <v-list-item-avatar>
        <v-icon>
          mdi-alert
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Action Alert</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon @click.prevent="minimize = !minimize">
          <v-icon v-if="!minimize">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <div v-if="!isActiveAlert && !minimize">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6" class="pb-0">
            <v-form ref="form">
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete
                      label="Type"
                      v-model="type"
                      :items="types"
                      item-text="display_name"
                      item-value="value"
                      required
                      :rules="rules.type"
                      prepend-icon="mdi-monitor-star"
                      outlined
                      clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                      label="Action"
                      v-model="action"
                      :items="actions"
                      item-text="display_name"
                      item-value="value"
                      prepend-icon="mdi-hammer"
                      outlined
                      clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-textarea
                  label="Description"
                  v-model="description"
                  required
                  clearable
                  :rules="rules.type"
                  prepend-icon="mdi-comment"
                  outlined
                  auto-grow
                  rows="1"
              />
            </v-form>
          </v-col>
          <v-col cols="12" md="6" class="pb-0">
            <v-btn class="ma-2" outlined large color="success" @click.stop="setTemplate('ALERT_COMMISSION')">Commission
              Collected
            </v-btn>
            <v-btn class="ma-2" outlined large color="primary" @click.stop="setTemplate('ALERT_UPLOAD')">Upload
              Documents
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn text color="warning" @click.stop="setAlert()" :disabled="loading">Set Alert</v-btn>
      </v-card-actions>
    </div>
    <div v-else-if="!minimize">
      <v-card-text>
        <v-alert type="info" outlined>You have an active alert for this application.</v-alert>
        <v-card outlined class="mb-3">
          <v-card-text :class="getColor(alert.type)+'--text'">
            {{ alert.description }}
          </v-card-text>
        </v-card>
        <v-alert v-if="alert.is_confirmed" type="warning" class="lighten-1">
          Agent confirmed this alert, please deactivate it if everything is in order.
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn text color="warning" @click.stop="unsetAlert()">Deactivate</v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>
<script>
import {errorNotification} from "@/components/utils";

const ALERT_TEMPLATES = {
  'ALERT_COMMISSION': {
    type: 'confirmation',
    description: 'Please, confirm when commission collected by pressing "Confirm" button.',
    action: 'complete-step'
  },
  'ALERT_UPLOAD': {
    type: 'upload',
    description: 'Please, upload documents and press "Done" to notify us.',
    action: ''
  }
}
export default {
  name: 'ApplicationAlertAdmin',
  props: {
    id: Number
  },
  data() {
    return {
      minimize: false,
      loading: false,
      type: null,
      description: null,
      action: '',
      isActiveAlert: false,
      alert: {},
      actions: [],
      types: [],
      rules: {
        type: [
          v => !!v || 'Type is required',
        ],
        description: [
          v => !!v || 'Description is required',
        ]
      }
    }
  },
  methods: {
    fetchData() {
      this.$axios.get('/applications/' + this.id + '/alert/', {})
          .then((response) => {
            this.alert = response.data
            if (this.alert.is_active) {
              this.isActiveAlert = true
            }
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    fetchOptions() {
      // Fetch possible options
      this.$axios.options('/application/alerts/')
          .then((response) => {
            let options = response.data
            this.actions = options.actions.POST.action.choices
            this.types = options.actions.POST.type.choices
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    setAlert() {
      if (this.$refs.form.validate()) {
        let alert = {
          type: this.type,
          description: this.description,
          application: this.id,
          action: this.action
        }
        this.loading = true
        this.$axios.post('/application/alerts/', alert)
            .then(() => {
              this.isActiveAlert = true
              this.fetchData()
              this.loading = false
            })
            .catch((error) => {
              errorNotification(error)
            })
            .finally(() => {
              this.loading = false
            })
      }
    },
    unsetAlert() {
      this.$axios.patch('/application/alerts/' + this.alert.id + '/', {
        is_active: false
      })
          .then(() => {
            this.isActiveAlert = false
            this.alert = {}
            this.fetchData()
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    getColor(type) {
      switch (type) {
        case 'confirmation':
          return 'success'
        case 'upload':
          return 'primary'
        case 'info':
          return 'info'
        case 'warning':
          return 'warning'
      }
      return 'info'
    },
    setTemplate(template) {
      let templates = ALERT_TEMPLATES
      this.type = templates[template].type
      this.description = templates[template].description
      this.action = templates[template].action
    }
  },
  mounted() {
    this.fetchOptions()
    this.fetchData()
  }
}
</script>